export const grommetStyles = {
  layer: {
    overlay: {
      background: 'rgba(0, 0, 0, 0.7)',
    },
  },
}
